import { createFileRoute } from '@tanstack/react-router';

import { ClinicalWorkPage } from '@/features/emr';

function NeedsAttentionPage() {
  return <ClinicalWorkPage initialView="attention" />;
}

export const Route = createFileRoute('/_authenticated/documents/')({
  component: NeedsAttentionPage,
  beforeLoad: () => ({
    breadcrumbs: [{ href: '/documents', title: 'Inbox' }],
  }),
});
